import { recordListUserInfo } from 'config/CustomEnums';
import { createModel } from 'models/BaseModel';
import {
  getBulkRewardList,
  getBulkRewardRecord,
} from 'services/BulkRewardRecordApiHelp';

import {
  getDetailPageDisplayLastModifiedDate,
  getListDisplayLastModifiedDate,
} from 'utils/TimeFormatUtil';

const getInitState = () => ({
  listDisplayFields: [
    { displayName: 'ID', fieldName: 'pk', orderField: 'pk', linked: true },
    ...recordListUserInfo,
    { displayName: 'Reward Type', fieldName: 'rewardTypeString' },
    {
      displayName: 'Point Added',
      fieldName: 'addPoints',
      orderField: 'addPoints',
    },
    {
      displayName: 'Point Removed',
      fieldName: 'removePoints',
      orderField: 'removePoints',
    },
    {
      displayName: 'Progress Points Added',
      fieldName: 'addTpes',
      orderField: 'addTpes',
    },
    {
      displayName: 'Progress Points Removed',
      fieldName: 'removeTpes',
      orderField: 'removeTpes',
    },
    { displayName: 'Coupon Set Added', fieldName: 'addCouponSetIds' },
    { displayName: 'Coupon Added', fieldName: 'addCouponAmount' },
    { displayName: 'Coupon Set Removed', fieldName: 'removeCouponSetIds' },
    { displayName: 'Coupon Removed', fieldName: 'removeCouponAmount' },
    { displayName: 'Stamp Campaign Added', fieldName: 'addStampCampaignIds' },
    { displayName: 'Stamp Added', fieldName: 'addStampCampaignQuantity' },
    {
      displayName: 'Stamp Campaign Remove',
      fieldName: 'removeStampCampaignIds',
    },
    { displayName: 'Stamp Removed', fieldName: 'removeStampCampaignQuantity' },
    { displayName: 'Creation time', fieldName: 'listDisplayCreationDate' },
  ],
});

// TODO: 修改parse中的type显示字段
const REWARD_TYPE = {
  ADD_POINTS: 'Add Points',
  REMOVE_POINTS: 'Remove Points',
  ADD_COUPONS: 'Add Coupons',
  REMOVE_COUPONS: 'Remove Coupons',
  ADD_STAMPS: 'Add Stamps',
  REMOVE_STAMPS: 'Remove Stamps',
  ADD_TPES: 'Add Progress Points',
  REMOVE_TPES: 'Remove Progress Points',
};
const parseBulkReward = (data) => {
  data.addCouponSetIds = Array(data.addCouponSetIds).join(); //type of addCouponSetIds is object
  data.addCouponAmount = Array(data.addCouponAmount).join();
  data.removeCouponSetIds = Array(data.removeCouponSetIds).join();
  data.removeCouponAmount = Array(data.removeCouponAmount).join();
  data.addStampCampaignIds = Array(data.addStampCampaignIds).join();
  data.addStampCampaignQuantity = Array(data.addStampCampaignQuantity).join();
  data.removeStampCampaignIds = Array(data.removeStampCampaignIds).join();
  data.removeStampCampaignQuantity = Array(
    data.removeStampCampaignQuantity,
  ).join();
  const rewardTypeString = data.rewardType
    .map((type) => REWARD_TYPE[type], this)
    .join();

  return {
    customerId: data.customer?.pk,
    name: data.customer
      ? data.customer?.nickname
        ? `${data.customer?.firstName} ${data.customer?.lastName} (${data.customer?.nickname})`
        : `${data.customer?.firstName} ${data.customer?.lastName}`
      : null,
    customerIsReset: data.customer?.isReset,
    mobilePhoneNumber: data.customer?.mobilePhoneNumberSubscriberNumber
    ? `+${data.customer.mobilePhoneNumberCountryCode}\r\n${data.customer.mobilePhoneNumberSubscriberNumber}` : null,
    email: data.customer?.emailAddress,
    customerName: data.customer?.nickname
      ? `${data.customer?.firstName} ${data.customer?.lastName} (${data.customer?.nickname})`
      : `${data.customer?.firstName} ${data.customer?.lastName}`,
    ...data,
    rewardTypeString,
    listDisplayCreationDate: getListDisplayLastModifiedDate(data?.creationDate),
    detailPageDisplayCreationDate: getDetailPageDisplayLastModifiedDate(
      data?.creationDate,
    ),
    addPointsExpiryDateDetailDisplay: getDetailPageDisplayLastModifiedDate(
      data?.addPointsExpiry,
    ),
  };
};

export default createModel({
  namespace: 'bulkReward',
  states: getInitState(),
  params: {
    listAPI: getBulkRewardList,
    parse: (data) => {
      return data?.bulkRewardRecords.edges.map((item) =>
        parseBulkReward(item.node),
      );
    },
    pkNode: 'BulkRewardRecordNode',
    detailAPI: getBulkRewardRecord,
    parseDetail: (data) => parseBulkReward(data.bulkRewardRecord),
    objectKey: 'bulkRewardRecords',
    initState: getInitState(),
  },
  reducers: {},
  effects: {},
});
